var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rendezvous-grid"},[_c('div',{staticClass:"grid-item"},[_c('h3',{staticClass:"steps-header"},[_vm._v("\n            "+_vm._s(_vm.getHeading)+"\n        ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getCopy))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }